import React, { useEffect } from "react";
import "./Details.css";
import { Accordion, Col, Row } from "react-bootstrap";
import defaultImage from "../../../../assets/images/package-img-default.png";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import transportationIcon from "../../../../assets/images/packages/svg/bus.svg"
import serviceIcon from "../../../../assets/images/packages/svg/services.svg"
import { useTranslation } from "../../../../contexts/TranslationContext";
import Cookies from "js-cookie";

dayjs.extend(duration);

const Details = ({ url, packageData }) => {
  const activities = packageData?.activites || {};
  const arrivalDescription = packageData?.arrival_description;
  const includes = packageData?.includes || [];
  const pricingType = packageData?.pricing_type;
  const { t } = useTranslation();
  const Lang = Cookies.get("preferred_language") || "en";

  const formatPrice = (price) => {
    const num = parseFloat(price);
    if (isNaN(num)) return "0";
    return num.toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  };

  // Process activities
  const days = Object.entries(activities).sort(
    ([a], [b]) => parseInt(a) - parseInt(b)
  );

  const accordionItems = days.flatMap(([dayNumber, dayActivities]) =>
    dayActivities.map((activity, index) => ({
      ...activity,
      description: activity.description,
      // description: dayNumber === '1' && index === 0 && arrivalDescription
      //     ? arrivalDescription
      //     : activity.description,
      uniqueKey: `${dayNumber}-${index}`,
    }))
  );

  const accordionItemsWithArrivalDeparture = [
    arrivalDescription && {
      uniqueKey: "arrival",
      day_id: "", 
      tour: t("Arrival"),
      description: arrivalDescription,
      isVirtual: true,    
    },
    ...accordionItems,
    packageData?.departure_description && {
      uniqueKey: "departure",
      day_id: "",  
      tour: t("Departure"),
      description: packageData.departure_description,
      isVirtual: true,
    },
  ].filter(Boolean); 


  // Process includes
  const filteredIncludes = includes.filter((item) => {
    const hasDescription = item.description && item.description.trim() !== "";
    const hasPrice =
      pricingType !== "Total Pricing" && parseFloat(item.price) > 0;
    return hasDescription || hasPrice;
  });

  const groupedIncludes = includes.reduce((acc, item) => {
    const type = (item.package_component_type || '').toLowerCase().trim();
    
    if (type.includes('flight')) {
      acc.transfers.push(item);
    } 
    else if (type.includes('hotel')) {
      acc.accommodation.push(item);
    }
    else if (type.includes('transport')) {
      acc.transportation.push(item);  
    }
    else if (type.includes('service')) {
      acc.service.push(item);
    }
    else {
      acc.others.push(item);
    }
    return acc;
  }, { transfers: [], accommodation: [], transportation: [], service: [], others: [] });


  
  


  const hasActivities = accordionItems.length > 0;
  const hasIncludes = filteredIncludes.length > 0;

  const calc_duration = (item) => {
    const datetime1 = dayjs(item.f_date_from);
    const datetime2 = dayjs(item.f_date_to);

    const diff = datetime2.diff(datetime1); // In milliseconds
    const dur = dayjs.duration(diff);

    var duration = "";
    if (dur.days()) {
      duration += `${dur.days()}d`;
    }
    if (dur.hours()) {
      duration += `${dur.hours()}h`;
    }
    if (dur.minutes()) {
      duration += `${dur.minutes()}min`;
    }
    if (dur.seconds()) {
      duration += `${dur.seconds()}sec`;
    }

    return duration;
  };

  return (
    <div className="details-package-container">
      {packageData.description && (
        <>
          <div className="details-package-title">{t("PackageDetails")}</div>
          <div
            className="details-package-desc"
            dangerouslySetInnerHTML={{ __html: packageData.description }}
          >
            {/* {packageData.description} */}
          </div>
        </>
      )}

      {hasActivities && (
        <>
          <div className="details-package-accordion-title">
            {t("SampleItinerary")}
          </div>
          {/* <Accordion className="details-package-accordion">
              {accordionItems.map((activity) => (
                <Accordion.Item
                  key={activity.uniqueKey}
                  eventKey={activity.uniqueKey}
                  className="details-package-accordion-item"
                >
                  <Accordion.Header className="details-package-accordion-header">
                    <span className="details-package-day">
                      {t("Day")} {activity.day_id}
                    </span>
                    {activity.tour || "Activity"}
                  </Accordion.Header>
                  <Accordion.Body className="details-package-form-accordion-body">
                    <div className="details-package-activity-description">
                      {activity.description && <p>{activity.description}</p>}
                      {pricingType !== "Total Pricing" &&
                        activity.price > 0 && (
                          <p>
                            {t("Price")}: {formatPrice(activity.price)}
                          </p>
                        )}
                    </div>
                    {activity.package_component_id && (
                      <div className="activity-activities-list-title">
                        {t("Activities")}:
                      </div>
                    )}
                    {activity.package_component_id && (
                      <div className="activity-activities-list-container">
                        <div className="activity-activities-card">
                          <div className="activity-activities-card-image">
                            <img
                              src={
                                activity.image
                                  ? url + "/" + activity.image
                                  : defaultImage
                              }
                            />
                          </div>
                          <div className="activity-activities-card-title">
                            {activity.activity_title}
                          </div>
                        </div>
                      </div>
                    )}
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion> */}

          {/* {packageData.arrival_description &&
            packageData.arrival_description.trim() !== "" && (
              <div className="arrival-description">
                <h4>"Arrival Description"</h4>
                <p>{packageData.arrival_description}</p>
              </div>
            )} */}

          {/* 
          <Accordion className="details-package-accordion">
            {accordionItemsWithArrivalDeparture.map((activity) => (
              <Accordion.Item
                key={activity.uniqueKey}
                eventKey={activity.uniqueKey}
                className="details-package-accordion-item"
              >
                <Accordion.Header className="details-package-accordion-header">
                  <span className="details-package-day">
                    {activity.day_id ? `${t("Day")} ${activity.day_id}` : ""}
                  </span>
                  {activity.tour || "Activity"}
                </Accordion.Header>
                <Accordion.Body className="details-package-form-accordion-body">
                  <div className="details-package-activity-description">
                    {activity.description && <p>{activity.description}</p>}
                    {!activity.isVirtual &&
                      pricingType !== "Total Pricing" &&
                      activity.price > 0 && (
                        <p>
                          {t("Price")}: {formatPrice(activity.price)}
                        </p>
                      )}
                  </div>

                  {!activity.isVirtual && activity.package_component_id && (
                    <>
                      <div className="activity-activities-list-title">
                        {t("Activities")}:
                      </div>
                      <div className="activity-activities-list-container">
                        <div className="activity-activities-card">
                          <div className="activity-activities-card-image">
                            <img
                              src={
                                activity.image
                                  ? url + "/" + activity.image
                                  : defaultImage
                              }
                              alt=""
                            />
                          </div>
                          <div className="activity-activities-card-title">
                            {activity.activity_title}
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion> */}

          <Accordion className="details-package-accordion">
            {packageData.arrival_description &&
              packageData.arrival_description.trim() !== "" && (
                <Accordion.Item
                  key="arrival"
                  eventKey="arrival"
                  className="details-package-accordion-item"
                >
                  <Accordion.Header className="details-package-accordion-header">
                    <span className="details-package-day details-package-day-arrival">{t("Arrival")}</span>
                  </Accordion.Header>

                  <Accordion.Body className="details-package-form-accordion-body">
                    <div className="day-activity-block">
                      <div className="details-package-activity-description">
                        <p>{packageData.arrival_description}</p>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              )}

            {days.map(([dayNumber, dayActivities]) => (
              <Accordion.Item
                key={dayNumber}
                eventKey={dayNumber}
                className="details-package-accordion-item"
              >
                <Accordion.Header className="details-package-accordion-header">
                  <span className="details-package-day">
                    {t("Day")} {dayNumber}
                  </span>
                </Accordion.Header>

                <Accordion.Body className="details-package-form-accordion-body">
                  {dayActivities.map((activity, index) => (
                    <div key={index}>
                      <div className="day-activity-block">
                        <div className="activity-activities-list-container">
                          <div className="activity-activities-card">
                            <div className="activity-activities-card-image">
                              <img
                                src={
                                  activity.image
                                    ? url + "/" + activity.image
                                    : defaultImage
                                }
                                alt={activity.activity_title}
                              />
                            </div>
                            <div className="activity-activities-card-title">
                              {activity.activity_title}
                            </div>
                          </div>
                        </div>

                        <div className="details-package-activity-description">
                          {activity.activity_description && (
                            <p
                              dangerouslySetInnerHTML={{
                                __html:
                                  Lang === "ar"
                                    ? activity.activity_description_ar
                                    : activity.activity_description,
                              }}
                            />
                          )}
                          {pricingType !== "Total Pricing" &&
                            parseFloat(activity.price) > 0 && (
                              <p>
                                {t("Price")}: {formatPrice(activity.price)}
                              </p>
                            )}
                        </div>
                      </div>

                      {index < dayActivities.length - 1 && (
                        <hr className="activity-separator" />
                      )}
                    </div>
                  ))}
                </Accordion.Body>
              </Accordion.Item>
            ))}

            
          {packageData.departure_description &&
            packageData.departure_description.trim() !== "" && (
              <Accordion.Item
                key="departure"
                eventKey="departure"
                className="details-package-accordion-item"
              >
                <Accordion.Header className="details-package-accordion-header">
                  <span className="details-package-day details-package-day-arrival">{t("Departure")}</span>
                </Accordion.Header>

                <Accordion.Body className="details-package-form-accordion-body">
                  <div className="day-activity-block">
                    <div className="details-package-activity-description">
                      <p>{packageData.departure_description}</p>
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            )}

          </Accordion>


          {/* {packageData.departure_description &&
            packageData.departure_description.trim() !== "" && (
              <div className="departure-description">
                <h4>"Departure Description"</h4>
                <p>{packageData.departure_description}</p>
              </div>
            )} */}
        </>
      )}

      {hasIncludes && (
        <div className="details-package-includes-container">
          <div className="details-package-accordion-title">
            {t("Inclusions")}
          </div>
          <Accordion className="details-package-accordion">
            {groupedIncludes.transfers.length > 0 && (
              <Accordion.Item
                eventKey="0"
                className="details-package-accordion-item"
              >
                <Accordion.Header className="details-package-accordion-header">
                  {t("Flights")}
                </Accordion.Header>
                <Accordion.Body className="details-package-form-accordion-body">
                  {groupedIncludes.transfers.map((item, index) => (
                    // <div key={index} className="inclusion-item">
                    //     {item.description && <p>{item.description}</p>}
                    //     {pricingType !== "Total Pricing" && parseFloat(item.price) > 0 && (
                    //         <p>Price: {formatPrice(item.price)}</p>
                    //     )}
                    // </div>

                    <div class="flight-card-list">
                      {item.description && (
                        <div className="inclusion-description">
                          <p>{item.description}</p>
                        </div>
                      )}
                      {item.departure_airport_abbr &&
                        item.f_date_from &&
                        item.arrival_airport_abbr &&
                        item.f_date_to && (
                          <div class="flight-card">
                            <div class="city city-from">
                              <span class="city-name">
                                {item.from_destination_name}
                              </span>
                              <span class="airport-code">
                                {item.departure_airport_abbr}
                              </span>
                              <div class="time-info">
                                <b class="time">
                                  {item.date_from
                                    ? new Date(
                                        item.f_date_from
                                      ).toLocaleTimeString([], {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                      })
                                    : ""}
                                </b>
                                <span class="date">
                                  {item.f_date_from
                                    ? dayjs(
                                        item.f_date_from.split(" ")[0]
                                      ).format("MMM D, YYYY")
                                    : ""}
                                </span>
                              </div>
                            </div>

                            <div class="flight-info">
                              <div className="line-before">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="101"
                                  height="1"
                                  viewBox="0 0 101 1"
                                  fill="none"
                                >
                                  <path
                                    d="M-0.00244141 0.504883H101.003"
                                    stroke="#B7B7B7"
                                    stroke-dasharray="2 2"
                                  />
                                </svg>
                              </div>
                              <div class="flight-duration">
                                <span className="airport-name">
                                  {Lang === "en"
                                    ? item.airline
                                    : item.airline_ar}
                                </span>
                                <span className="flight-time">
                                  {calc_duration(item)}
                                </span>
                              </div>

                              <div className="line-before">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="101"
                                  height="6"
                                  viewBox="0 0 101 6"
                                  fill="none"
                                  className="line-before-svg"
                                >
                                  <path
                                    d="M101.005 3L96.005 0.113249V5.88675L101.005 3ZM0 3V3.5H1.01005V3V2.5H0V3ZM3.03015 3V3.5H5.05025V3V2.5H3.03015V3ZM7.07035 3V3.5H9.09044V3V2.5H7.07035V3ZM11.1105 3V3.5H13.1306V3V2.5H11.1105V3ZM15.1507 3V3.5H17.1708V3V2.5H15.1507V3ZM19.1909 3V3.5H21.211V3V2.5H19.1909V3ZM23.2311 3V3.5H25.2512V3V2.5H23.2311V3ZM27.2713 3V3.5H29.2914V3V2.5H27.2713V3ZM31.3115 3V3.5H33.3316V3V2.5H31.3115V3ZM35.3517 3V3.5H37.3718V3V2.5H35.3517V3ZM39.3919 3V3.5H41.412V3V2.5H39.3919V3ZM43.4321 3V3.5H45.4522V3V2.5H43.4321V3ZM47.4723 3V3.5H49.4924V3V2.5H47.4723V3ZM51.5125 3V3.5H53.5326V3V2.5H51.5125V3ZM55.5527 3V3.5H57.5728V3V2.5H55.5527V3ZM59.5929 3V3.5H61.613V3V2.5H59.5929V3ZM63.6331 3V3.5H65.6532V3V2.5H63.6331V3ZM67.6733 3V3.5H69.6934V3V2.5H67.6733V3ZM71.7135 3V3.5H73.7336V3V2.5H71.7135V3ZM75.7537 3V3.5H77.7738V3V2.5H75.7537V3ZM79.7939 3V3.5H81.814V3V2.5H79.7939V3ZM83.8341 3V3.5H85.8542V3V2.5H83.8341V3ZM87.8743 3V3.5H89.8944V3V2.5H87.8743V3ZM91.9145 3V3.5H93.9346V3V2.5H91.9145V3ZM95.9547 3V3.5H97.9748V3V2.5H95.9547V3Z"
                                    fill="#B7B7B7"
                                  />
                                </svg>
                              </div>
                            </div>

                            <div class="city  city-to">
                              <span class="city-name">
                                {item.to_destination_name}
                              </span>
                              <span class="airport-code">
                                {item.arrival_airport_abbr}
                              </span>
                              <div class="time-info">
                                <b class="time">
                                  {item.f_date_to
                                    ? new Date(
                                        item.f_date_to
                                      ).toLocaleTimeString([], {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                      })
                                    : ""}
                                </b>
                                <span class="date">
                                  {item.f_date_to
                                    ? dayjs(
                                        item.f_date_to.split(" ")[0]
                                      ).format("MMM D, YYYY")
                                    : ""}
                                </span>
                              </div>
                            </div>
                          </div>
                        )}
                    </div>
                  ))}
                </Accordion.Body>
              </Accordion.Item>
            )}

            {groupedIncludes.accommodation.length > 0 && (
              <Accordion.Item
                eventKey="1"
                className="details-package-accordion-item"
              >
                <Accordion.Header className="details-package-accordion-header">
                  {t("Accommodation")}
                </Accordion.Header>
                <Accordion.Body className="details-package-form-accordion-body">
                  <Row className="accommodation-hotels-container">
                    {groupedIncludes.accommodation.map((item, index) => (
                      <>
                        {item.description && (
                          <div className="accommodation-hotel-description">
                            <p>{item.description}</p>
                          </div>
                        )}
                        <div className="accommodation-hotel">
                          {/* <div className="accommodation-hotel-image"> */}
                          {/* <img src={defaultImage} /> */}
                          {/* </div> */}
                          <div className="accommodation-hotel-content">
                            <div className="accommodation-hotel-title">
                              {item.hotel_name}
                            </div>
                            <div className="accommodation-hotel-location">
                              {item.from_destination_name}
                            </div>
                            <div className="accommodation-hotel-location">
                            {pricingType !== "Total Pricing" &&
                            parseFloat(item.price) > 0 && (
                              <p>
                                {t("Price")}: {formatPrice(item.price)}
                              </p>
                            )}
                            </div>
                          </div>
                        </div>
                      </>
                    ))}
                  </Row>
                </Accordion.Body>
              </Accordion.Item>
            )}

            {(groupedIncludes.transportation.length > 0 ||
              groupedIncludes.service.length > 0 ||
              groupedIncludes.others.length > 0) && (
              <Accordion.Item
                eventKey="2"
                className="details-package-accordion-item"
              >
                <Accordion.Header className="details-package-accordion-header">
                  {t("Others")}
                </Accordion.Header>
                <Accordion.Body className="details-package-form-accordion-body">
                  {groupedIncludes.transportation.length > 0 && (
                    <>
                      <h5 className="inclusion-subheading">
                        <img
                          src={transportationIcon}
                          alt="Transportation Icon"
                          className="inclusion-icon"
                        />
                        <div>{t("Transportation")}</div>
                      </h5>
                      {groupedIncludes.transportation.map((item, index) => (
                        <div
                          key={`transportation-${index}`}
                          className="inclusion-item"
                        >
                          {item.description && <p>{item.description}</p>}
                          {pricingType !== "Total Pricing" &&
                            parseFloat(item.price) > 0 && (
                              <p>
                                {t("Price")}: {formatPrice(item.price)}
                              </p>
                            )}
                        </div>
                      ))}
                    </>
                  )}

                  {groupedIncludes.service.length > 0 && (
                    <>
                      <h5 className="inclusion-subheading">
                        <img
                          src={serviceIcon}
                          alt="Service Icon"
                          className="inclusion-icon"
                        />
                        <div>{t("Service")}</div>
                      </h5>
                      {groupedIncludes.service.map((item, index) => (
                        <div
                          key={`service-${index}`}
                          className="inclusion-item"
                        >
                          {item.package_component_id && (
                            <div className="package-service-id">
                              {item.package_component_id}
                            </div>
                          )}
                          {item.description && <p>{item.description}</p>}

                          {pricingType !== "Total Pricing" &&
                            parseFloat(item.price) > 0 && (
                              <p>
                                {t("Price")}: {formatPrice(item.price)}
                              </p>
                            )}
                        </div>
                      ))}
                    </>
                  )}

                  {groupedIncludes.others.length > 0 && (
                    <>
                      <h5 className="inclusion-subheading">
                        {t("Other Inclusions")}
                      </h5>
                      {groupedIncludes.others.map((item, index) => (
                        <div key={`others-${index}`} className="inclusion-item">
                          {item.description && <p>{item.description}</p>}
                          {pricingType !== "Total Pricing" &&
                            parseFloat(item.price) > 0 && (
                              <p>
                                {t("Price")}: {formatPrice(item.price)}
                              </p>
                            )}
                        </div>
                      ))}
                    </>
                  )}
                </Accordion.Body>
              </Accordion.Item>
            )}
          </Accordion>
        </div>
      )}

      {packageData.terms_details && (
        <>
          <div className="details-package-title package-terms">
            {t("PackageTerms")}
          </div>
          <div className="details-package-desc">
            {/* {packageData.description} */}
            <p
              dangerouslySetInnerHTML={{ __html: packageData.terms_details }}
            ></p>
          </div>
        </>
      )}
    </div>
  );
};

export default Details;
